import * as tslib_1 from "tslib";
import noop from 'lodash/noop';
import * as React from 'react';

var IntervalRunner =
/** @class */
function (_super) {
  tslib_1.__extends(IntervalRunner, _super);

  function IntervalRunner() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.intervalId = null; // Methods

    _this.start = function () {
      var _a = _this.props,
          isActive = _a.isActive,
          interval = _a.interval,
          action = _a.action;

      if (isActive) {
        _this.intervalId = window.setInterval(action, interval * 1000);
      }
    };

    _this.stop = function () {
      if (_this.intervalId) {
        window.clearInterval(_this.intervalId);
        _this.intervalId = null;
      }
    };

    _this.restart = function () {
      _this.stop();

      _this.start();
    };

    return _this;
  }

  IntervalRunner.prototype.componentDidMount = function () {
    this.start();
  };

  IntervalRunner.prototype.componentDidUpdate = function (prevProps) {
    var prevIsActive = prevProps.isActive,
        prevAction = prevProps.action,
        prevInterval = prevProps.interval;
    var _a = this.props,
        isActive = _a.isActive,
        action = _a.action,
        interval = _a.interval;

    if (prevIsActive !== isActive || prevInterval !== interval || prevAction !== action) {
      this.restart();
    }
  };

  IntervalRunner.prototype.componentWillUnmount = function () {
    this.stop();
  };

  IntervalRunner.prototype.render = function () {
    return this.props.children;
  };

  IntervalRunner.defaultProps = {
    isActive: false,
    interval: 30,
    action: noop
  };
  return IntervalRunner;
}(React.PureComponent);

export default IntervalRunner;